import {
    booleanAttribute,
    Component,
    effect,
    input,
    model,
    ModelSignal,
} from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { FormValueControl } from "@angular/forms/signals";

export const controlValueAccessorProvider = (component: any) => ({
    provide: NG_VALUE_ACCESSOR,
    useExisting: component,
    multi: true,
});

@Component({
    selector: "app-value-accessor-adapter",
    template: "",
})
export class ControlValueAccessorAdpater<T = any>
    implements ControlValueAccessor, FormValueControl<T | undefined>
{
    value: ModelSignal<T | undefined> = model<T | undefined>(undefined);
    value$ = toObservable(this.value);
    disabled = model<boolean>(false);

    onChange = (_: T | undefined) => {};
    onTouched = () => {};

    constructor() {
        effect(() => {
            this.onChange(this.value()!);
        });

        effect(() => {
            if (this.disabled()) {
                // Handle disabled state change if needed internally or just expose the signal
            }
        });
    }

    writeValue(value: T | undefined): void {
        this.value.set(value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled.set(isDisabled);
    }

    touch() {
        this.onTouched();
    }
}
